import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Toasted from 'vue-toasted';
import Vuelidate from 'vuelidate';
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
Vue.config.productionTip = false


Vue.use(Toasted, {
  duration: 5000,
  position: 'bottom-right',
  theme:'toasted-primary',
  action : {
    text : 'Okay',
    onClick : (e, toastObject) => {
        toastObject.goAway(0);
    }
  }
})

Vue.use(Vuelidate)



//Setting up default vue's http modules for api calls
Vue.prototype.$http = axios
//load the token from localstorage
const token = localStorage.getItem("token")
//Is there any token then we will simply append default axios authorization headers
if(token){
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}





new Vue({

  router,
  store,
  render: h => h(App)
}).$mount('#app')
